<template>
  <div class="row bg-light-grey shadow-sm p-3 my-2 mx-1 rounded">
    <div class="col-4 text-center" style="border-right: 2px solid #fff">
      <div>
        <i
          class="fa fa-md"
          :class="
            invoice_document ? 'fa-check text-green' : 'fa-times text-danger'
          "
        ></i>
        Invoice
        <span class="required-flag">*</span>
      </div>
      <el-button
        :class="!invoice_document && 'btn-secondary'"
        class="py-1 px-4"
        @click="$emit('show')"
        :type="invoice_document ? 'info' : ''"
        :plain="invoice_document"
        >Upload
      </el-button>
    </div>
    <div class="col-4 text-center" style="border-right: 2px solid #fff">
      <div>
        <i
          class="fa fa-md"
          :class="
            rfid_document ? 'fa-check text-green' : 'fa-times text-danger'
          "
        ></i>
        RFIDs
        <span class="required-flag">*</span>
      </div>
      <el-button
        :class="!rfid_document && 'btn-secondary'"
        class="py-1 px-4"
        @click="$emit('show')"
        :type="rfid_document ? 'info' : ''"
        :plain="rfid_document"
        >Upload
      </el-button>
    </div>
    <div class="col-4 text-center">
      <div>
        <i
          class="fa fa-md"
          :class="
            additional_documents
              ? 'fa-check text-green'
              : 'fa-times text-danger'
          "
        ></i>
        Additional Docs
      </div>
      <el-button
        :class="!additional_documents && 'btn-secondary'"
        class="py-1 px-4"
        @click="$emit('show')"
        :type="additional_documents ? 'info' : ''"
        :plain="additional_documents"
        >Upload
      </el-button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    fileList: {
      type: Array,
      required: false,
      default: () => {
        return [];
      },
    },
    media: {
      type: Array,
      required: false,
      default: () => {
        return [];
      },
    },
  },
  data: () => ({
    invoice_document: false,
    rfid_document: false,
    additional_documents: false,
  }),
  mounted() {
    this.validateDocuments();
  },
  methods: {
    validateDocuments() {
      this.invoice_document = false;
      this.rfid_document = false;
      this.additional_documents = false;

      let rfid = this.media.filter(
        (f) => f.collection_name == "nlis_file_(rfid's)"
      ).length;
      if (rfid > 0) this.rfid_document = true;
      else {
        rfid = this.fileList.filter(
          (f) => f.collection_name == "nlis_file_(rfid's)"
        ).length;
        if (rfid > 0) this.rfid_document = true;
      }

      let invoice = this.media.filter(
        (f) => f.collection_name == "invoice"
      ).length;
      if (invoice > 0) this.invoice_document = true;
      else {
        invoice = this.fileList.filter(
          (f) => f.collection_name == "invoice"
        ).length;
        if (invoice > 0) this.invoice_document = true;
      }

      let additional = this.media.filter(
        (f) => f.collection_name == "additional_documents"
      ).length;
      if (additional > 0) this.additional_documents = true;
      else {
        additional = this.fileList.filter(
          (f) => f.collection_name == "additional_documents"
        ).length;
        if (additional > 0) this.additional_documents = true;
      }
    },
  },
};
</script>
